import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      image
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      readedAt
      __typename
    }
  }
  `;

  // export const shiftAppsByComId = gql/* GraphQL */ `
  // query ShiftAppsByComId(
  //   $comId: ID!
  //   $createdAt: ModelStringKeyConditionInput
  //   $filter: ModelAgendaShiftApplicationFilterInput
  //   $limit: Int
  //   $nextToken: String
  //   $sortDirection: ModelSortDirection
  // ) {
  //   shiftAppsByComId(
  //     comId: $comId
  //     createdAt: $createdAt
  //     filter: $filter
  //     limit: $limit
  //     nextToken: $nextToken
  //     sortDirection: $sortDirection
  //   ) {
  //     items {
  //       accepted
  //       comId
  //       createdAt
  //       deleted
  //       info
  //       role
  //       location
  //       shiftAppId
  //       shiftId
  //       startAt
  //       stopAt
  //       suspended
  //       updatedAt
  //       userId
  //       username
  //       __typename
  //     }
  //     nextToken
  //     __typename
  //   }
  // }
  // `;

  export const updateAgendaShift = gql/* GraphQL */ `mutation UpdateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: UpdateAgendaShiftInput!
) {
  updateAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const createAgendaShift = gql/* GraphQL */ `mutation CreateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: CreateAgendaShiftInput!
) {
  createAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const shiftsByComId = gql/* GraphQL */ `query ShiftsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        image
      }
    }
    nextToken
    __typename
  }
}
`;

export const usersByComId = gql/* GraphQL */ `
  query UsersByComId(
    $comId: ID!
    $filter: ModelAgendaUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    usersByComId(
      comId: $comId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        FCMtoken
        comId
        createdAt
        email
        firstName
        image
        isConfirmed
        language
        lastName
        password
        phoneNumber
        profileOwner
        readedAt
        role
        suspended
        type
        updatedAt
        userId
        username
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

  export const createAgendaShiftByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftByUserId(
  $accepted: Boolean
  $comId: ID
  $confirmed: Boolean
  $createdAt: AWSDateTime
  $deleted: Boolean
  $info: String
  $location: String
  $performance: String
  $punctuality: String
  $quality: String
  $rate: String
  $role: String
  $shiftAppId: ID
  $shiftId: ID!
  $startAt: AWSDateTime
  $stopAt: AWSDateTime
  $suspended: Boolean
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
  $lat: String
  $lng: String
) {
  createAgendaShiftByUserId(
    accepted: $accepted
    comId: $comId
    confirmed: $confirmed
    createdAt: $createdAt
    deleted: $deleted
    info: $info
    location: $location
    performance: $performance
    punctuality: $punctuality
    quality: $quality
    rate: $rate
    role: $role
    shiftAppId: $shiftAppId
    shiftId: $shiftId
    startAt: $startAt
    stopAt: $stopAt
    suspended: $suspended
    updatedAt: $updatedAt
    userId: $userId
    username: $username
    lat: $lat
    lng: $lng
  ) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;